<template>
  <div class="wai">
    <div class="curd">
      <div class="sou">
        <span style="margin-right: 10px;">角色名称</span>
        <el-input v-model="content" style="width: 240px;margin-right: 20px;" placeholder="角色名称（模糊搜索）" clearable />
        <el-button round @click="getlist()">查询</el-button>
      </div>
    </div>
    <div class="zhu">
      <el-collapse v-model="active">
        <el-collapse-item v-for="(item,index) in list" :key="index" :title="item.name" :name="item.id">
          <div>
            <el-button plain round @click="add(item.id)">+角色</el-button>
          </div>
          <el-table :data="item.rolelist" style="width: 100%"><!-- :show-header="false" -->
            <el-table-column prop="id" label="id" />
            <el-table-column prop="name" label="角色名称" />
            <el-table-column prop="description" label="描述" />
            <el-table-column prop="create_time" label="创建时间" />
            <el-table-column prop="update_time" label="修改时间" />
            <el-table-column label="操作">
              <template #default="{ row }">
                <el-button type="primary" @click="upd(row)" size="small">修改</el-button>
                <el-button type="primary" @click="del(row)" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog @close="dialogclose()" v-model="dialog" width="400" :close-on-click-modal="false">
      <div class="adddig">
        <div v-if="curdtype == 1">
          <div class="group">
            <div class="lab">
              角色名称
            </div>
            <div class="inp">
              <el-input v-model="rolename" style="width: 240px" placeholder="请输入角色名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              角色描述
            </div>
            <div class="inp">
              <el-input v-model="roleeg" style="width: 240px" placeholder="请输入角色描述(可空)" />
            </div>
          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="addjuese()">添加角色</el-button>
          </div>
        </div>
        <div v-if="curdtype == 2">
          <div class="group">
            <div class="lab">
              原角色名称
            </div>
            <div class="inp">
              <el-input disabled v-model="oldname" style="width: 240px" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              新角色名称
            </div>
            <div class="inp">
              <el-input v-model="rolename" style="width: 240px" placeholder="请输入新角色名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              角色描述
            </div>
            <div class="inp">
              <el-input v-model="roleeg" style="width: 240px" placeholder="请输入角色描述" />
            </div>
          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="updjuese()">修改角色</el-button>
          </div>
        </div>
        <div v-if="curdtype == 3">
          <div class="group">
            <div class="lab">
              是否确定删除
            </div>
            <div class="inp">
              <el-input disabled v-model="oldname" style="width: 240px" />
            </div>
          </div>
          <div style="display: flex;justify-content: center;">
            <el-button style="width: 150px;" type="info" @click="dialog = false">取消</el-button>
            <el-button style="width: 150px;" type="danger" @click="deljuese()">确认删除</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script setup>
  import {
    ElMessage
  } from 'element-plus';
  import {
    onMounted,
    reactive,
    ref
  } from 'vue';
  import {
    addrole,
    delrole,
    getrolelist,
    updrole
  } from '@/api/api'
  onMounted(() => {
    getlist()
  })
  const dialog = ref(false)
  const curdtype = ref(1)

  //折叠面板的
  const active = ref([])
  //模糊搜索的
  const content = ref()
  //角色curd需要
  const rolename = ref()
  const roleeg = ref()
  const did = ref()
  const rid = ref()
  const oldname = ref()

  const list = ref()
  const getlist = async () => {
    const data = {
      content: content.value
    }
    const res = await getrolelist(data)
    if (res.code == 200) {
      list.value = res.data.list
    } else {
      ElMessage.error(res.message)
    }
  }
  const addjuese = async () => {
    if (rolename.value == "" || rolename.value == null) {
      ElMessage.error("角色名称不能为空！")
      return
    }
    const data = {
      name: rolename.value,
      department_id: did.value,
      description: roleeg.value
    }
    const res = await addrole(data)
    if (res.code == 200) {
      ElMessage.success("角色添加成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }
  const updjuese = async () => {
    const data = {
      role_id: rid.value,
      name: rolename.value,
      description: roleeg.value
    }
    const res = await updrole(data)
    if (res.code == 200) {
      ElMessage.success("角色修改成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }
  const deljuese = async () => {
    const data = {
      role_id: rid.value
    }
    const res = await delrole(data)
    if (res.code == 200) {
      ElMessage.success("角色删除成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }
  const add = (id) => {
    curdtype.value = 1
    did.value = id
    dialog.value = true
  }
  const upd = (row) => {
    curdtype.value = 2
    rid.value = row.id
    oldname.value = row.name
    roleeg.value = row.description
    dialog.value = true
  }
  const del = (row) => {
    oldname.value = row.name
    rid.value = row.id
    curdtype.value = 3
    dialog.value = true
  }

  const dialogclose = () => {
    curdtype.value = 1
    rolename.value = ''
    roleeg.value = ''
    did.value = ''
    rid.value = ''
    oldname.value = ''
  }
</script>

<style lang="scss" scoped>
  .wai {
    width: 100%;
    height: 100%;
    padding: 0 20px;


    .curd {
      height: 50px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .zhu {
      width: 100%;
      height: calc(100% - 45px - 50px);
      overflow-y: auto;
      border-radius: 10px;

      .biao {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .tou {
          font-weight: bolder;
          color: #000;
          height: 40px;
          background-color: #dddddd;
        }

        .shen {
          height: 40px;
          color: #000;
          text-align: center;
          font-size: 16px;
        }

        .shen:nth-child(odd) {
          background-color: #F5F7FA;
        }
      }
    }

    .page {
      height: 45px;
      width: 100%;
      display: flex;
      padding: 0 30px;
      justify-content: right;
    }
  }

  .adddig {
    .group {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 10px 0px;

      .lab {
        padding-left: 20px;
        width: 130px;
      }
    }
  }
</style>
